import IExtendedSearchQueryFilter from "@app/interfaces/dtos/IExtendedSearchQueryFilter";
import { FilterProcessingService } from "@app/routing/FilterProcessingService";
import { CountryFilterMapper } from "@app/routing/mappers/CountryFilterMapper";
import { getPortalTypeFromEnvClient } from "@app/utils/get-portal-type-from-env.client";
import { getPortalTypeFromEnvServer } from "@app/utils/get-portal-type-from-env.server";
import { getPortalPathFromType } from "@app/utils/portal-detector";
import { FilterType } from "@studyportals/omnisearch-interfaces";
import { useRouter } from "vue-router";
import { PortalType } from "@studyportals/domain-client";
import { ROUTE_PREFIX } from "@generator/config/route-prefix";
import { SearchType } from "@domain/enums/SearchType";

const convertFromCountryISOToID = (key: FilterType, value: string): string => {
	if(key === FilterType.COUNTRY) {
		if(value.split(',').length > 1) {
			return value.split(',').map(iso => convertFromCountryISOToID(key, iso)).join(',');
		}
		return CountryFilterMapper.getInstance().getCountryIdFromIsoCode(value) || '';
	}

	return value;
}

const buildQueryFromFilters = (filters: IExtendedSearchQueryFilter[]): string => {
	const portalType = (import.meta.client) ? getPortalTypeFromEnvClient() : getPortalTypeFromEnvServer();
	const shouldKeepEducationLevelInQuery = portalType === PortalType.DISTANCE_LEARNING;
	const queryString =
		filters
			.filter(filter => shouldKeepEducationLevelInQuery || filter.type !== FilterType.EDUCATION_LEVEL)
			.map((filter) => {
				const values = filter.values.map(value => value.id).join(',');
				if(filter.type  === FilterType.ATTENDANCE) {
					return `mh=${values}`;
				}

				if (filter.type === FilterType.COUNTRY) {
					return `${filter.type}=${convertFromCountryISOToID(filter.type, values)}`;
				}

				return `${filter.type}=${values}`;
			})
			.join("&");

	const queryPrefix = queryString ? "?" : "";

	return 	`${queryPrefix}${queryString}`;
}

export const useGenerateSearchTypeUrl = async (searchType: SearchType): Promise<string> => {
	const router = useRouter();
	const portalType = (import.meta.client) ? getPortalTypeFromEnvClient() : getPortalTypeFromEnvServer();
	const searchPath = getPortalPathFromType(portalType);
	const prefix = router.currentRoute.value.path.startsWith(ROUTE_PREFIX) ? ROUTE_PREFIX : '';

	const filters = await FilterProcessingService.getInstance().processRoute(router.currentRoute.value);

	const formattedQuery = buildQueryFromFilters(filters);

	const redirectPath = `${prefix}/search/${searchType}/${searchPath}`;

	return `${redirectPath}${formattedQuery}`;
}
